import React from 'react'
import { NextSeo } from 'next-seo'
import LegalTemplate from '@/src/components/Legal/LegalTemplate'
const LEGAL_CONTENT = `
# **Coupon Terms**
**Last Updated:** August 14, 2023

Coupons are a great way to save even more when shopping with us, and it is easy to use them at our stores. When accepting coupons, you’re agreeing to follow the Coupon Terms along with Orka’s [Privacy Policy](/legal/PrivacyPolicy) and [Terms of Service](/legal/TermsOfService). 

**Eligibility**

Only invited users who are registered on Orka's official website are eligible for a coupon. The coupon is linked to your Orka account and may only be used for purchases made using your account with the same user ID. 

**Usage & Redemption**

Coupons can be used during the checkout process. Each coupon is identified by a unique code and is entitled to a single use per order on Orka’s official website. You should enter the coupon code into the designated box for the discount to be automatically applied to the price of the qualifying purchase. If you fail to enter the coupon code at the time of purchase, the purchase will not be eligible for the discount. Discounts can not be claimed by post-purchase confirmation.

**Coupon Validity**

Please note that coupons are non-transferable and cannot be used in combination with any other discount or coupons provided by Orka. Each coupon is valid for a specific time frame indicated in the email sent to you by Orka. Coupons cannot be retrospectively applied to previous purchases. During certain periods, especially peak seasons, coupons may be exempt from use.

**Order Cancellation and Product Returns**

If an order made using a coupon code is canceled before product shipment, the coupon may or may not be reusable. You may reuse non-single-use coupons. However, for single-use coupons, the coupon can not be reused even if an order is canceled.

**Product-Specific Coupons**

Please note that certain coupons may apply only to Orka hearing aids and not other accessories or items. Details for the applicability of each coupon will be provided via email distributing the coupon.  

**No cash value**

The coupon has no cash value and cannot be transferred, forwarded, or exchanged.
If you become entitled to receive a refund for an item purchased using the coupon, the amount of refund payable to you will not include the coupon or its redemption value.

**Cannot be applied to shipping**

The discount applies to the purchase price for the item excluding any shipping, handling, and taxes.

**General**

Orka reserves the right to modify, cancel, discontinue, or suspend any coupon at its discretion, at any time. Orka will not be held liable for any kind of damage, injury, or loss incurred as a result of the acceptance or usage of the coupon, except as required by law.
`

const CouponTerms = () => {
  return (
    <>
      <LegalTemplate legalCopy={LEGAL_CONTENT} />
      <NextSeo
        title="Coupon Terms｜Orka - Hear What Matters"
        description="By using the promo codes offered by Orka, you hereby acknowledge and agree with the coupon terms."
      />
    </>
  )
}

export default CouponTerms
